import $ from 'jquery';
import 'eonasdan-bootstrap-datetimepicker';
import moment from 'moment';

export function datepicker(context) {
    $('.input-group.date input', context).each(function () {
        let $this = $(this),
            defaultOptions = {
                useCurrent: $this.val() ? false : ($this.is('[data-use-current]') && $this.attr('data-use-current')==false ? false: true),
                format: $this.attr('data-format') ? $this.attr('data-format') : 'YYYY-MM-DD',
                viewMode: $this.is('[data-view-mode]') ? $this.attr('data-view-mode') : 'days',
                viewDate: $this.is('[data-view-date]') ? $this.attr('data-view-date') : false,
                locale: navigator.language || 'en',
                icons: {
                    time: 'bi bi-clock',
                    date: 'bi bi-calendar-event',
                    up: 'bi bi-chevron-up',
                    down: 'bi bi-chevron-down',
                    previous: 'bi bi-chevron-left',
                    next: 'bi bi-chevron-right',
                    today: 'bi bi-calendar2-check',
                    clear: 'bi bi-trash',
                    close: 'bi bi-x'
                },
                debug: false
            },
            filledDatesClass = $this.is('[data-filled-dates-class]') ? eval($this.attr('data-filled-dates-class')) : 'highlight-date',
            classifyCallback = $this.is('[data-classify-callback]') ? eval($this.attr('data-classify-callback')) : null;

        if ($this.attr('data-min-date')) {
            defaultOptions.minDate = moment($this.attr('data-min-date') ? $this.attr('data-min-date') : new Date()).toDate();
        }
        if ($this.attr('data-max-date')) {
            defaultOptions.maxDate = moment($this.attr('data-max-date') ? $this.attr('data-max-date') : new Date()).toDate();
        }

        var options = JSON.parse($this.attr('data-datepicker-options') || '{}');
        $.extend(options, defaultOptions);

        // Filled dates functionality
        if ($this.is('[data-filled-dates]')) {
            var highlightDates = $.map(JSON.parse($this.attr('data-filled-dates')), function(e){ return e; });
            $this.on('dp.change', function (e) {
                if (!e.oldDate) {
                    return;
                }

                let dateFormat = $(this).attr('data-format');
                if (e.oldDate.format(dateFormat) !== e.date.format(dateFormat)) {
                    var $form = $(this).closest('form');
                    var dateChangedInput = $form.find($this.is('[data-date-changed-input]') ? $this.attr('data-date-changed-input') : ':input[name="date_changed"]');
                    if (dateChangedInput.length) {
                        dateChangedInput.val('1');
                        $form.submit();
                    }
                }
            });
            $this.on('dp.classify', function(e){
                if (highlightDates.indexOf(e.date.format('YYYY-MM-DD'))!==-1) {
                    e.classNames.push(filledDatesClass);
                }
                if (classifyCallback) {
                    classifyCallback(e);
                }
            });
        }

        $this.datetimepicker(options).trigger('dp.create');
    }).parent().on('click', function(){
        $(this).find(':input').focus();
    });
}

export default {
    datepicker
};